"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconPencil = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M25.07 59.39H9.49V43.81l37.19-37.2 15.58 15.58zm-12.58-3h11.34L58 22.19 46.68 10.86 12.49 45z"
  }), _react["default"].createElement("path", {
    d: "M40.183 15.235l2.122-2.122L55.76 26.57l-2.122 2.12zM26.36 57.47h-3v-5.09h-6.75v-6.7h-5.37v-3h8.37v6.7h6.75v8.09z"
  })),
  height: undefined,
  width: undefined
});
IconPencil.displayName = 'IconPencil';
var _default = IconPencil;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/pencil.js
// module id = 158
// module chunks = 0